/* Stats Actions */
export const FETCH_STATS = 'FETCH_STATS';
export const FETCH_STATS_SUCCESS = 'FETCH_STATS_SUCCESS';
export const FETCH_STATS_FAIL = 'FETCH_STATS_FAIL';

export const FETCH_WORLDMAP = 'FETCH_WORLDMAP';
export const FETCH_WORLDMAP_SUCCESS = 'FETCH_WORLDMAP_SUCCESS';
export const FETCH_WORLDMAP_FAIL = 'FETCH_WORLDMAP_FAIL';
export const FETCH_NUMBER_OF_PLAYERS = 'FETCH_NUMBER_OF_PLAYERS';
export const FETCH_NUMBER_OF_PLAYERS_SUCCESS =
    'FETCH_NUMBER_OF_PLAYERS_SUCCESS';
export const FETCH_NUMBER_OF_PLAYERS_FAIL = 'FETCH_NUMBER_OF_PLAYERS_FAIL';
export const FETCH_NUMBER_OF_PLAYERS_WITH_OPEN_ALERTS =
    'FETCH_NUMBER_OF_PLAYERS_WITH_OPEN_ALERTS';
export const FETCH_NUMBER_OF_PLAYERS_WITH_OPEN_ALERTS_SUCCESS =
    'FETCH_NUMBER_OF_PLAYERS_WITH_OPEN_ALERTS_SUCCESS';
export const FETCH_NUMBER_OF_PLAYERS_WITH_OPEN_ALERTS_FAIL =
    'FETCH_NUMBER_OF_PLAYERS_WITH_OPEN_ALERTS_FAIL';
export const FETCH_NUMBER_OF_ACTIVE_PLAYERS = 'FETCH_NUMBER_OF_ACTIVE_PLAYERS';
export const FETCH_NUMBER_OF_ACTIVE_PLAYERS_SUCCESS =
    'FETCH_NUMBER_OF_ACTIVE_PLAYERS_SUCCESS';
export const FETCH_NUMBER_OF_ACTIVE_PLAYERS_FAIL =
    'FETCH_NUMBER_OF_ACTIVE_PLAYERS_FAIL';
export const FETCH_NUMBER_OF_EVENTS_FOR_THE_LAST_DAY =
    'FETCH_NUMBER_OF_EVENTS_FOR_THE_LAST_DAY';
export const FETCH_NUMBER_OF_EVENTS_FOR_THE_LAST_DAY_SUCCESS =
    'FETCH_NUMBER_OF_EVENTS_FOR_THE_LAST_DAY_SUCCESS';
export const FETCH_NUMBER_OF_EVENTS_FOR_THE_LAST_DAY_FAIL =
    'FETCH_NUMBER_OF_EVENTS_FOR_THE_LAST_DAY_FAIL';
export const FETCH_TOP_RISKY_PLAYERS = 'FETCH_TOP_RISKY_PLAYERS';
export const FETCH_TOP_RISKY_PLAYERS_SUCCESS =
    'FETCH_TOP_RISKY_PLAYERS_SUCCESS';
export const FETCH_TOP_RISKY_PLAYERS_FAIL = 'FETCH_TOP_RISKY_PLAYERS_FAIL';
export const FETCH_REGISTRATIONS_PER_MONTH = 'FETCH_REGISTRATIONS_PER_MONTH';
export const FETCH_REGISTRATIONS_PER_MONTH_SUCCESS =
    'FETCH_REGISTRATIONS_PER_MONTH_SUCCESS';
export const FETCH_REGISTRATIONS_PER_MONTH_FAIL =
    'FETCH_REGISTRATIONS_PER_MONTH_FAIL';
export const FETCH_OVERALL_SYSTEM_RISK = 'FETCH_OVERALL_SYSTEM_RISK';
export const FETCH_OVERALL_SYSTEM_RISK_SUCCESS =
    'FETCH_OVERALL_SYSTEM_RISK_SUCCESS';
export const FETCH_OVERALL_SYSTEM_RISK_FAIL = 'FETCH_OVERALL_SYSTEM_RISK_FAIL';
export const FETCH_OPEN_ALERTS_PER_RULE_CATEGORY =
    'FETCH_OPEN_ALERTS_PER_RULE_CATEGORY';
export const FETCH_OPEN_ALERTS_PER_RULE_CATEGORY_SUCCESS =
    'FETCH_OPEN_ALERTS_PER_RULE_CATEGORY_SUCCESS';
export const FETCH_OPEN_ALERTS_PER_RULE_CATEGORY_FAIL =
    'FETCH_OPEN_ALERTS_PER_RULE_CATEGORY_FAIL';
